<template>
  <div class="auto-set">
    <el-form :model="setForm" ref="setForm" class="setForm" :labelWidth="70">
      <el-form-item
        v-for="(item, index) in setForm.classes"
        :key="index"
        :label="index == 0 ? '时间段' : '&nbsp;'"
      >
        <el-row :style="{ width: '100%' }">
          <el-col :span="4">
            <el-form-item
              :rules="setFormRules.classes"
              :prop="'classes.' + index + '[0]'"
            >
              <el-time-picker
                :disabled="!editable"
                v-model="setForm.classes[index][0]"
                placeholder="开始时间"
                format="HH:mm"
              >
              </el-time-picker>
            </el-form-item>
          </el-col>
          <el-col :span="1" style="color: #fff; text-align: center">-</el-col>
          <el-col :span="4">
            <el-form-item
              :rules="setFormRules.classes"
              :prop="'classes.' + index + '[1]'"
            >
              <el-time-picker
                :disabled="!editable"
                v-model="setForm.classes[index][1]"
                placeholder="结束时间"
                format="HH:mm"
              >
              </el-time-picker
            ></el-form-item>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item label="&nbsp;" v-if="editable">
        <el-button type="primary" @click="add" round>新增</el-button>
        <el-button @click="remove" round>减少</el-button>
      </el-form-item>
      <!-- <div class="subBox">
        <el-form-item label="&nbsp;" v-if="editable">
          <el-button type="primary" @click="submit">保存</el-button>
        </el-form-item>
      </div> -->
    </el-form>
    <div v-if="editable" class="subBox">
      <el-button type="primary" @click="submit">保存</el-button>
    </div>
  </div>
</template>

<script>
import moment from "moment";

import { send } from ".././../socket/index";
export default {
  name: "Page",
  components: {},
  methods: {
    async init() {
      try {
        let res = await this.$myRequest({
          url: "/getClassSetReq",
          method: "post",
        });
        res = res.data;

        window.xxx = moment();
        window.moment = moment;
        this.time0 = moment(
          moment().format("YYYY-MM-DD") + " 00:00:00"
        ).toDate();
        this.time24 = moment(
          moment().format("YYYY-MM-DD") + " 24:00:00"
        ).toDate();
        res = JSON.parse(JSON.stringify(res));
        res.data.classes = res.data.classes.map((v, k) => {
          return [
            moment(moment().format("YYYY-MM-DD") + " " + v.st).toDate(),
            moment(moment().format("YYYY-MM-DD") + " " + v.et).toDate(),
          ];
        });
        this.setForm = res.data;
      } catch (err) {
        console.log("err form init");
        console.log(err);
      }
    },
    submit() {
      this.$refs["setForm"].validate(async (valid) => {
        if (valid) {
          let classes = JSON.parse(JSON.stringify(this.setForm.classes));
          classes = classes.map((v, k) => {
            return {
              st: moment(v[0]).format("H:m"),
              et: moment(v[1]).format("H:m"),
            };
          });

          let res = await this.$myRequest({
            url: "/saveClassSetReq",
            method: "post",
            data: { classes },
          });
          this.init();
        }
      });

      // console.log(JSON.stringify(this.setForm));
    },
    typeChange() {},

    add() {
      this.setForm.classes.push([undefined, undefined]);
    },
    remove() {
      // console.log("remove");
      if (this.setForm.classes.length > 1) {
        this.setForm.classes.pop();
      }
    },
    checkJiao(oClass, tClass) {
      let st = oClass[0]?.getTime();
      let et = oClass[1]?.getTime();
      let tst = tClass[0]?.getTime();
      let tet = tClass[1]?.getTime();
      let isJiao = false;
      if (st < et && tst < tet) {
        //都不跨天
        isJiao =
          (st >= tst && st <= tet) ||
          (et >= tst && et <= tet) ||
          (st <= tst && et >= tet);
      } else if (st > et && tst > tet) {
        //都跨天
        //注意，都跨天包含了 原区域包含目标区域的情况，所以下面的判断少了包含判断
        isJiao = true;
      } else if (st < et && tst > tet) {
        //目标区域跨天
        isJiao =
          (st >= tst && st <= this.time24) ||
          (st >= this.time0 && st <= tet) ||
          (et >= tst && et <= this.time24) ||
          (et >= this.time0 && et <= tet);
      } else if (st > et && tst < tet) {
        //原区域跨天，将上一个比较反过来比即可，反正都是区域
        isJiao =
          (tst >= st && tst <= this.time24) ||
          (tst >= this.time0 && tst <= et) ||
          (tet >= st && tet <= this.time24) ||
          (tet >= this.time0 && tet <= et);
      }
      return isJiao;
    },
  },
  data() {
    return {
      time0: null,
      time24: null,

      setFormRules: {
        classes: [
          { required: true, message: "必填" },
          {
            validator: (rule, value, callback) => {
              // console.log("time valid ");
              // console.log(value);
              // console.log(this.setForm);
              // debugger;
              let err = 0;
              let msg = "时间区间设置错误";
              this.setForm.classes.forEach((v, k) => {
                let st = v[0]?.getTime();
                let et = v[1]?.getTime();

                if (st == et) {
                  //
                  console.log("开时间与结束时间不可以相等");
                  msg = "开时间与结束时间不可以相等";
                  err = 1;
                } else {
                  //先判断与下一个班次是否交集
                  if (
                    this.setForm.classes.length >= 2 &&
                    this.checkJiao(
                      v,
                      this.setForm.classes[
                        (k + 1) % this.setForm.classes.length
                      ]
                    )
                  ) {
                    console.log("班次之间不可以有交集");
                    msg = "班次之间不可以有交集";

                    err = 1;
                  } else if (this.setForm.classes.length >= 3) {
                    //判断与下一个班次之间是否插有其他班次
                    let checkIndex = (k + 2) % this.setForm.classes.length;
                    while (checkIndex != k) {
                      if (
                        this.checkJiao(this.setForm.classes[checkIndex], [
                          v[1],
                          this.setForm.classes[
                            (k + 1) % this.setForm.classes.length
                          ][0],
                        ])
                      ) {
                        console.log("相邻班次之间不可以插入其他班次");
                        msg = "相邻班次之间不可以插入其他班次";
                        err = 1;
                        break;
                      }
                      checkIndex =
                        (checkIndex + 1) % this.setForm.classes.length;
                    }
                  }
                }
              });
              if (err) {
                callback(new Error(msg));
              } else {
                callback();
              }
            },
            // message: "时间区间设置错误",
          },
        ],
      },
      setForm: {
        classes: [],
      },
      editable: true,
    };
  },
  mounted() {
    this.init();

    if (this.$route.name == "userAutoSet") {
      this.editable = false;
    }

    this.$store.commit("checkTick");
  },
};
</script>
<style scoped lang="less" src="./index.less"></style>
